<template>
    <div class="message loading">
      <div class="bubble">
        <avatar-robot></avatar-robot>
      </div>
      <img :src="baseUrl + 'ellipsis.gif'" alt="">
    </div>
</template>

<script>
import AvatarRobot from '../components/AvatarRobot'
export default {
  components: {
    AvatarRobot
  },
  computed: {
      baseUrl () {
          return process.env.BASE_URL
      }
  },
  mounted () {

  }
}
</script>